import { ValidatorFn } from '@angular/forms';
import { ProductExistsValidator } from '@shared/validators/product/product-exists';

export class U2bProductValidators {
    public static productExists(message?: string): ValidatorFn {
        return new ProductExistsValidator(message).asValidatorFn();
    }
}
